import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [

  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  // {
  //   path: '/register',
  //   component: () => import('@/views/login/register'),
  //   hidden: true,
  //   meta: {
  //     requireAuth: false
  //   }
  // },
  {
    path: '/tokenLogin',
    component: () => import('@/views/login/token'),
    hidden: true,
    meta: {
      requireAuth: false
    }
  },

  {
    path: '/test',
    component: () => import('@/views/test/index'),
    hidden: true,
    meta: {
      requireAuth: false
    }
  },

  {
    path: '/test/login',
    component: () => import('@/views/test/login'),
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
    meta: {
      requireAuth: false
    }
  },



  {
    path: '/',
    component: () => import('@/views/index'),
    meta: {
      permissionRedirect: true
    },
  },

  // {
  //   path: '/homePage',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'Home',
  //   meta: {
  //     id: 2,
  //     icon: "home",
  //     title:"Home",
  //     role:[1,2,3]
  //   },
  //   children: [{
  //     path: '/homePage/index',
  //     component: () => import('@/views/homePage/index'),
  //     name: 'HomePage',
  //     meta: {
  //       title: 'Home',
  //       role:[1,2,3]
  //     },

  //   }
  //   ]
  // },
  // {
  //   path: '/detailPage',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'Detail',
  //   meta: {
  //     id: 2,
  //     icon: "assets",
  //     title:"Detail",
  //     role:[1,2,3]
  //   },
  //   children: [{
  //     path: '/detailPage/index',
  //     component: () => import('@/views/detailPage/index'),
  //     name: 'DetailPage',
  //     meta: {
  //       title: 'Detail',
  //       role:[1,2,3]
  //     },

  //   }
  //   ]
  // },
  // {
  //   path: '/alarmEvent',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'AlarmEvent',
  //   meta: {
  //     id: 2,
  //     icon: "alarm",
  //     title:"Alarm Event",
  //     role:[1,2,3]
  //   },
  //   children: [{
  //     path: '/alarmEvent/index',
  //     component: () => import('@/views/alarmEventPage/index'),
  //     name: 'AlarmEvent',
  //     meta: {
  //       title: 'Alarm Event',
  //       role:[1,2,3]
  //     },

  //   }
  //   ]
  // },
  // {
  //   path: '/paramSet',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'ParamSet',
  //   meta: {
  //     role:[1,2,3],
  //     icon: "param-set",
  //     title:"Param Set",
  //     requireAuth: false,
  //   },
  //   children: [{
  //     path: '/paramSet/index',
  //     component: () => import('@/views/paramSetPage/index'),
  //     name: 'ParamSet',
  //     meta: {
  //       title: 'Param Set',
  //       requireAuth: false,
  //       role:[1,2,3]
  //     },

  //   }
  //   ]
  // },

  //   {
  //     path: '/userManager',
  //     component: Layout,
  //     redirect: 'noRedirect',
  //     name: 'userManager',
  //     meta: {
  //       id: 2,
  //       icon: "device-manager",
  //       title:"Device Manager",
  //       role:[1,2,3]
  //     },
  //     children: [{
  //       path: '/userManager/index',
  //       component: () => import('@/views/userManager/index'),
  //       name: 'UserManager',
  //       meta: {
  //         title: 'User Manager',
  //         role:[1,2,3]
  //       },

  //     }
  //     ]
  //   },

  // {
  //   path: '/deviceManager',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'DeviceManager',
  //   meta: {
  //     id: 2,
  //     icon: "device-manager",
  //     title:"Device Manager",
  //     role:[1,2,3]
  //   },
  //   children: [{
  //     path: '/deviceManager/index',
  //     component: () => import('@/views/deviceManager/index'),
  //     name: 'DeviceManager',
  //     meta: {
  //       title: 'Device Manager',
  //       role:[1,2,3]
  //     },

  //   }
  //   ]
  // },









  // 404 page must be placed at the end !!!
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export const endUserRouter = [
  //end user 路由开始
  // {
  //   path: '/home',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'OperationStatus',
  //   meta: {
  //     id: 2,
  //     icon: "home",
  //     title: "Home",
  //     role: [5],
  //   },
  //   children: [{
  //       path: '/home/index',
  //       component: () => import('@/views/home/index'),
  //       name: 'homes',
  //       meta: {
  //         title: 'Home',
  //         role: [5],
  //       },
  //     }
  //   ]
  // },
  // {
  //   path: '/deviceManager',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'faultyDevices',
  //   meta: {
  //     id: 2,
  //     icon: "device-manager",
  //     title: "Devices",
  //     role: [5],
  //   },
  //   children: [
  //     {
  //       path: '/deviceManager/index',
  //       component: () => import('@/views/deviceManager/index'),
  //       name: 'Statistics',
  //       meta: {
  //         title: 'Device List',
  //         role: [5],
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/endUserPage/faultyDevices',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'faultyDevices',
  //   meta: {
  //     id: 2,
  //     icon: "alarm",
  //     title: "Devices",
  //     role: [5],
  //   },
  //   children: [
  //     {
  //       path: '/endUserPage/faultyDevices/index',
  //       component: () => import('@/views/endUserPage/faultyDevices/index'),
  //       name: 'faultyDevices',
  //       meta: {
  //         title: 'Event',
  //         role: [5],
  //       },
  //     },
  //   ]
  // },
  // {
  //   path: '/paramSetPage',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'faultyDevices',
  //   meta: {
  //     id: 2,
  //     icon: "param-set",
  //     title: "Devices",
  //     role: [5],
  //   },
  //   children: [
  //     {
  //       path: '/paramSet/index',
  //       component: () => import('@/views/paramSetPage/index'),
  //       name: 'ParameterSetting',
  //       meta: {
  //         title: 'Parameter Setting',
  //         requireAuth: false,
  //         role: [5],
  //       },
  //     },
  //   ]
  // },
  // {
  //   path: '/endUserPage/systemUpgrade',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'faultyDevices',
  //   meta: {
  //     id: 2,
  //     icon: "upgrade",
  //     title: "Devices",
  //     role: [5],
  //   },
  //   children: [
  //     {
  //       path: '/endUserPage/systemUpgrade/index',
  //       component: () => import('@/views/endUserPage/systemUpgrade/index'),
  //       name: 'systemUpgrades',
  //       meta: {
  //         title: 'Upgrade',
  //         role: [5],

  //       },
  //     },
  //   ]
  // },
  // {
  //   path: '/endUserPage/faultyDevices',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'faultyDevices',
  //   meta: {
  //     id: 2,
  //     icon: "note-2",
  //     title: "Devices",
  //     role: [5],
  //   },
  //   children: [
  //     {
  //       path: '/deviceManager/index',
  //       component: () => import('@/views/deviceManager/index'),
  //       name: 'Statistics',
  //       meta: {
  //         title: 'Device List',
  //         role: [5],
  //       }
  //     },
  //     {
  //       path: '/endUserPage/faultyDevices/index',
  //       component: () => import('@/views/endUserPage/faultyDevices/index'),
  //       name: 'faultyDevices',
  //       meta: {
  //         title: 'Event',
  //         role: [5],
  //       },
  //     },
  //     {
  //       path: '/paramSet/index',
  //       component: () => import('@/views/paramSetPage/index'),
  //       name: 'ParameterSetting',
  //       meta: {
  //         title: 'Parameter Setting',
  //         requireAuth: false,
  //         role: [5],
  //       },
  //     },
  //     {
  //       path: '/endUserPage/systemUpgrade/index',
  //       component: () => import('@/views/endUserPage/systemUpgrade/index'),
  //       name: 'systemUpgrades',
  //       meta: {
  //         title: 'Upgrade',
  //         role: [5],

  //       },
  //     },
  //   ]
  // },
  // {
  //   path: '/endUserPage',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'personalInformation',
  //   meta: {
  //     id: 2,
  //     icon: "teacher",
  //     title:"Account",
  //     role:[4],
  //   },
  //   children: [{
  //     path: '/endUserPage/personalInformation/index',
  //     component: () => import('@/views/endUserPage/personalInformation/index'),
  //     name: 'personalInformation',
  //     meta: {
  //       title: 'Personal Information',
  //       role:[3,4],
  //     },
  //   }
  //   ]
  // },


  // {
  //   path: '/statisticalAnalysis',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'StatisticalAnalysis',
  //   meta: {
  //     id: 2,
  //     icon: "note-2",
  //     title:"Statistical Analysis",
  //     role:[4],
  //   },
  //   children: [{
  //     path: '/statisticalAnalysis/index',
  //     component: () => import('@/views/statisticalAnalysis/index'),
  //     name: 'StatisticalAnalysis',
  //     meta: {
  //       title: 'Statistical Analysis',
  //       role:[4],
  //     },
  //   },
  //   ]
  // },
  // {
  //   path: '/basicInfo',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'basicInfo',
  //   meta: {
  //     id: 2,
  //     icon: "teacher",
  //     title:"Account  Management",
  //     role:[4],

  //   },
  //   children: [
  //     {
  //       path: '/basicInfo/index',
  //       component: () => import('@/views/basicInfo/index'),
  //       name: 'basicInfo',
  //       meta: {
  //             title: 'Basic Info',
  //             role:[4],
  //       },
  //     },
  //     {
  //       path: '/deviceMangement/index',
  //       component: () => import('@/views/deviceMangement/index'),
  //       name: 'deviceMangement',
  //       meta: {
  //         title: 'Device Mangement',
  //         role:[4],

  //       },
  //     },
  //  ]
  // },
  //end user 路由结束
]
export const installerRouter = [
  //install 路由开始
  {
    path: '/home',
    component: Layout,
    redirect: 'noRedirect',
    name: 'home',
    meta: {
      id: 2,
      icon: "home",
      title: "Home",
      role: [1, 2, 3, 4 ,5],
    },
    children: [{
      path: '/home/index',
      component: () => import('@/views/home/index'),
      name: 'home',
      meta: {
        title: 'Home',
        role: [1, 2, 3, 4 ,5],
      },
    }]
  },
  {
    path: '/operationStatuss',
    component: Layout,
    redirect: 'noRedirect',
    name: 'devData',
    meta: {
      role: [0, 1, 2, 3, 4 ],
      icon: "assets",
      title: "Device",
    },
    children: [{
        path: '/operationStatuss/index',
        component: () => import('@/views/operationStatuss/index'),
        name: 'operationStatuss',
        meta: {
          title: 'Monitioring Device',
          role: [0, 1, 2, 3, 4, 5],
        }
      }
    ]
  },
  {
    path: '/deviceManager',
    component: Layout,
    redirect: 'noRedirect',
    name: 'Devices',
    meta: {
      id: 2,
      icon: "device-manager",
      title: "Devices",
      role: [0, 1, 2, 3, 4 ,5],
    },
    children: [
      {
        path: '/deviceManager/index',
        component: () => import('@/views/deviceManager/index'),
        name: 'Device List',
        meta: {
          title: 'Device List',
          role: [0, 1, 2, 3, 4 ,5],
        }
      }
    ]
  },
  {
    path: '/endUserPage/systemUpgrade',
    component: Layout,
    redirect: 'noRedirect',
    name: 'Statistics',
    meta: {
      role: [0, 1, 2],
      icon: "upgrade",
      title: "Device Management",
    },
    children: [
      {
        path: '/endUserPage/systemUpgrade/index',
        component: () => import('@/views/endUserPage/systemUpgrade/index'),
        name: 'systemUpgrades',
        meta: {
          title: 'Upgrade',
          role: [0, 1, 2],
        },
      },
    ]
  },
  {
    path: '/endUserPage/faultyDevices',
    component: Layout,
    redirect: 'noRedirect',
    name: 'Statistics',
    meta: {
      role: [0, 1, 2, 3, 4 ,5],
      icon: "alarm",
      title: "Device Management",
    },
    children: [
      {
        path: '/endUserPage/faultyDevices/index',
        component: () => import('@/views/endUserPage/faultyDevices/index'),
        name: 'faultyDevices',
        meta: {
          title: 'Event',
          role: [0, 1, 2, 3, 4 ,5],
        },
      },
    ]
  },
  {
    path: '/paramSet',
    component: Layout,
    redirect: 'noRedirect',
    name: 'Statistics',
    meta: {
      role: [0, 1, 2],
      icon: "param-set",
      title: "Device Management",
    },
    children: [
      {
        path: '/paramSet/index',
        component: () => import('@/views/paramSetPage/index'),
        name: 'ParameterSetting',
        meta: {
          title: 'Parameter Setting',
          role: [0, 1, 2],
        },
      }
    ]
  },
  {
    path: '/secondDistributorUserManager/index',
    component: Layout,
    redirect: 'noRedirect',
    name: 'userManager',
    meta: {
      role: [0, 1, 2, 3],
      icon: "customer",
      title: "User Management",
    },
    children: [{
        path: '/secondDistributorUserManager/index',
        component: () => import('@/views/secondDistributorUserManager/index'),
        name: 'secondDistributorUserManager',
        meta: {
          title: 'User Mangement',
          role: [0, 1, 2, 3]
        }
      },
      //  {
      //   path: '/distributorUserManager/index',
      //   component: () => import('@/views/distributorUserManager/index'),
      //   name: 'Installer-User',
      //   meta: {
      //     title: 'Installer-User Mangement',
      //     role:[0,1,2]
      //   }
      //   },
      // {
      //   path: '/userManager/index',
      //   component: () => import('@/views/userManager/index'),
      //   name: 'End-User',
      //   meta: {
      //     title: 'End-User Mangement',
      //     role: [4]
      //   }
      // },
      // {
      //   path: '/installerInfo/index',
      //   component: () => import('@/views/installerInfo/index'),
      //   name: 'InstallationInfo',
      //   meta: {
      //     title: 'Installation Info',
      //     role:[0,1,2,3]
      //   }
      // },


    ]
  },
  {
    path: '/userManager/index',
    component: Layout,
    redirect: 'noRedirect',
    name: 'userManager',
    meta: {
      role: [4],
      icon: "customer",
      title: "User Management",
    },
    children: [
      {
        path: '/userManager/index',
        component: () => import('@/views/userManager/index'),
        name: 'End-User',
        meta: {
          title: 'End-User Mangement',
          role: [4]
        }
      },
    ]
  },
  {
    path: '/accountBasicInfo/index',
    component: Layout,
    redirect: 'noRedirect',
    name: 'AccountManagement',
    meta: {
      role: [1, 2, 3, 4, 5],
      icon: "user",
      title: "Account",
    },
    children: [{
        path: '/endUserPage/personalInformation/index',
        component: () => import('@/views/endUserPage/personalInformation/index'),
        name: 'personalInformation',
        meta: {
          title: 'Personal Information',
          role: [1, 2, 3, 4, 5],
        },
      },


    ]
  },
  //install 路由结束
]


const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [...constantRoutes, ...endUserRouter, ...installerRouter]
})


const router = createRouter()


// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
